import {Box, Stack, styled} from '@mui/material';

export const StyledStack = styled(Stack)`
	padding: 8px 16px 8px 8px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 8px 24px 16px 16px;
	}
`;

export const StyledStepsContent = styled(Box)(({theme}) => ({
	paddingBottom: 72,
	[theme.breakpoints.up('sm')]: {
		paddingBottom: 0,
	},
}));
